'use es6';

import styled from 'styled-components';
var UICardHero = styled.div.withConfig({
  displayName: "UICardHero",
  componentId: "vxv3pb-0"
})(["border-top-left-radius:inherit;border-top-right-radius:inherit;overflow:hidden;"]);
UICardHero.displayName = 'UICardHero';
export default UICardHero;